<template>
    <div class="col-md-8 p-0 mr-5">
        <div class="calculator__step">
            <div class="calculator__step--top">
                <b>STORAGE CALCULATOR</b>
            </div>
            <div class="row m-0 calculator__step--contentResult p-4">
                <div>
                    <h4 class="m-0"> {{mainData.shipment | capitalize}} </h4>
                    <p class="mb-2">Your shipment cathegorised as <b :class="(totalValue >= 13) ? 'status__green-text' : (totalValue > 9) ? 'status__yellow-text' : 'status__red-text'"> {{(totalValue >= 13) ? 'GREEN' : (totalValue > 9) ? 'YELLOW' : 'RED' }} </b> type based on your data.</p>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th class="text-left pl-2">Description</th>
                            <th>Basic Rates</th>
                            <th>{{`Volume (${mainData.volume_parameter})`}}</th>
                            <th>Type</th>
                            <th>{{mainData.expectedDays}} Days</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in resultData.table" :key="i">
                            <td class="text-left pl-2">{{item.description}}</td>
                            <td>{{addCommas(item.basicRates)}}</td>
                            <td>{{item.volume}}</td>
                            <td>{{item.type}}</td>
                            <td>{{item.days ? addCommas(item.days) : '-' }}</td>
                        </tr>
                    </tbody>
                </table>
                 <div class=" bottomsection row m-0 justify-content-between w-100">
                    <b class="pl-2" style="width: 60%">Total</b>
                    <b class="text-right pr-2" style="width: 20%">IDR</b>
                    <b class="text-center" style="width: 20%">{{addCommas(resultData.total)}}</b>
                </div>
                <div class="w-100 row m-0 calculator__step--bottom justify-content-end pb-3 pt-3">
                    <button class="_global__button--corporite pl-4 pr-4 ml-4" @click="emitToParent('StartCalculator')">Recalculate</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'ResultCalculator',
  props: {
    mainData: Object,
    totalValue: Number,
    resultData: Object
  },
  data: () => ({
    payloadLog: {
      featureName: 'STORAGE CALCULATOR',
      featureStep: 6,
      stepName: 'Finish, Result Calculator',
      featureProcess: {
        status: 'success',
        data: {}
      }
    }
  }),
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // insert log
      this.payloadLog.featureProcess.data = this.resultData
      this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
    },
    emitToParent (data) {
      this.$emit('activeForm', { stepName: data })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/storagecalculator/ResultCalculator.vue